import { UserRole } from '@/resource/user/user.model';
import { getRole } from './cookie';

const isAdmin = () => {
  const role = getRole();
  const roles = [UserRole.Admin, UserRole.SuperAdmin];

  if (role && roles.includes(role)) {
    return true;
  } else {
    return false;
  }
};

export default isAdmin;
